import { render, staticRenderFns } from "./EndpointBasedApp.vue?vue&type=template&id=766d31b8&"
import script from "./EndpointBasedApp.vue?vue&type=script&lang=js&"
export * from "./EndpointBasedApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports